export const getInitialValue = (initialValue: unknown, key: string) => {
  const item = localStorage.getItem(key)
  if (item !== null) {
    return JSON.parse(item)
  }
  return initialValue
}

export const safeLocalStorage = {
  getItem: (key, defaultValue) => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch (error) {
      console.error(`Error retrieving key "${key}" from localStorage:`, error)
      return defaultValue
    }
  },

  setItem: (key, value) => {
    try {
      const stringValue = JSON.stringify(value)
      localStorage.setItem(key, stringValue)
    } catch (error) {
      console.error(`Error setting key "${key}" in localStorage:`, error)
    }
  },

  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key)
    } catch (error) {
      console.error(`Error removing key "${key}" from localStorage:`, error)
    }
  },

  clear: () => {
    try {
      window.localStorage.clear()
    } catch (error) {
      console.error("Error clearing localStorage:", error)
    }
  },
}
